import { FileMessage } from '@sendbird/chat/message';

export type Slide = {
  url: string;
  type: 'image' | 'video' | 'document';
  name?: string;
};

export const fileMessagesToSlides = (fileMessages: FileMessage[]): Slide[] => {
  return fileMessages.map((fileMessage) => {
    const url = fileMessage.url;
    let type: 'image' | 'video' | 'document';

    if (fileMessage.type.startsWith('image/')) {
      type = 'image';
    } else if (fileMessage.type === 'image') {
      type = 'image';
    } else if (fileMessage.type.startsWith('video/')) {
      type = 'video';
    } else {
      type = 'document';
    }

    return {
      url,
      type,
      name: fileMessage.name,
    };
  });
};
